// === CONFIGURAZIONE ===
const DUPLICATE_CHECK_HOURS = 24;
const STORAGE_KEY = 'easycodsell_orders';

// === VARIABILI GLOBALI ===
window.allowSubmit = false;
window.pendingOrder = null;
window.phoneVerified = false;

// === FUNZIONI DI STORAGE ===
function getSavedOrders() {
    try {
        const orders = localStorage.getItem(STORAGE_KEY);
        return orders ? JSON.parse(orders) : [];
    } catch (e) {
        console.error('Errore nel recupero ordini:', e);
        return [];
    }
}

function saveOrder(orderData) {

    try {
          // PROBLEMA CORRETTO: Prima controllo se i dati sono validi
        if (!orderData.customerName || orderData.customerName.length < 2) {
            console.log('📝 Nome mancante o troppo corto, lascio passare la validazione EasyCodSell');
            return null;
        }
        
        if (!orderData.phone || orderData.phone.length < 5) {
            console.log('📝 Telefono mancante o troppo corto, lascio passare la validazione EasyCodSell');
            return null;
        }
        const orders = getSavedOrders();
        //Inseriamo nell'array, che si trova nel local storage, l'ordine appena effettuato
        orders.push({
            ...orderData,
            timestamp: Date.now(),
            id: Date.now() + Math.random()
        });
        
        // Mantieni solo gli ordini delle ultime 48 ore
        const cutoff = Date.now() - (48 * 60 * 60 * 1000);
        //Creiamo un nuovo array solo con gli ordini avvenuti entro le ultime 48 ore
        const recentOrders = orders.filter(order => order.timestamp > cutoff);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(recentOrders));

        
        console.log('💾 Ordine salvato:', orderData);
    } catch (e) {
        console.error('Errore nel salvataggio ordine:', e);
    }
}

function checkForDuplicate(newOrderData) {

    // PROBLEMA CORRETTO: Prima controllo se i dati sono validi
    if (!newOrderData.customerName || newOrderData.customerName.length < 2) {
        console.log('📝 Nome mancante o troppo corto, lascio passare la validazione EasyCodSell');
        return null;
    }
    
    if (!newOrderData.phone || newOrderData.phone.length < 5) {
        console.log('📝 Telefono mancante o troppo corto, lascio passare la validazione EasyCodSell');
        return null;
    }

    const orders = getSavedOrders();
    const cutoff = Date.now() - (DUPLICATE_CHECK_HOURS * 60 * 60 * 1000);
    
    return orders.find(order => {
        if (order.timestamp < cutoff) return false;

        // Controlla duplicato per telefono + prodotto
        if (order.phone === newOrderData.phone && 
            order.productName === newOrderData.productName) {
            return true;
        }

        // Controlla duplicato per email + prodotto (se email presente)
        if (newOrderData.email && order.email === newOrderData.email && 
            order.productName === newOrderData.productName) {
            return true;
        }

        return false;
    });
}

// === FUNZIONI POPUP ===
function showDuplicateWarning(previousOrder, newOrderData) {
    console.log('🚨 Mostro popup per duplicato:', previousOrder);
    
    const overlay = document.getElementById('duplicateWarningOverlay');
    if (!overlay) {
        console.error('❌ Elemento duplicateWarningOverlay non trovato!');
        return;
    }
    
    const prevTime = new Date(previousOrder.timestamp).toLocaleString('it-IT');

    // Popola i dettagli dell'ordine precedente
    const prevOrderTime = document.getElementById('prevOrderTime');
    const prevOrderProduct = document.getElementById('prevOrderProduct');
    const prevOrderPhone = document.getElementById('prevOrderPhone');
    
    if (prevOrderTime) prevOrderTime.textContent = `📅 Data: ${prevTime}`;
    if (prevOrderProduct) prevOrderProduct.textContent = `📦 Prodotto: ${previousOrder.productName}`;
    if (prevOrderPhone) prevOrderPhone.textContent = `📞 Telefono: ${previousOrder.phone}`;

    // Salva l'ordine pending
    window.pendingOrder = newOrderData;
    
    // Mostra l'overlay
    overlay.style.display = 'flex';
    overlay.classList.add('show');
    
    console.log('✅ Popup mostrato con successo');
}

function hideDuplicateWarning() {
    const overlay = document.getElementById('duplicateWarningOverlay');
    if (overlay) {
        overlay.style.display = 'none';
        overlay.classList.remove('show');
    }
}

function showPhoneVerificationPopup(orderData) {
    const overlay = document.getElementById('phoneVerificationOverlay');
    if (!overlay) return;
    
    const currentPhoneDisplay = document.getElementById('currentPhoneDisplay');
    const phoneInput = document.getElementById('phoneVerificationInput');
    
    if (currentPhoneDisplay) currentPhoneDisplay.textContent = orderData.phone || 'Non inserito';
    if (phoneInput) phoneInput.value = orderData.phone || '';
    
    window.pendingOrder = orderData;
    overlay.style.display = 'flex';
    
    if (phoneInput) setTimeout(() => phoneInput.focus(), 100);
}

function hidePhoneVerificationPopup() {
    const overlay = document.getElementById('phoneVerificationOverlay');
    if (overlay) overlay.style.display = 'none';
}

// Funzione per validare il formato del numero di telefono
function validatePhoneNumber(phone) {
    // Rimuovi tutti i caratteri non numerici tranne + iniziale
    const cleanPhone = phone.replace(/[^\d+]/g, '');
    
    // Controlli di validazione
    if (!cleanPhone) return { valid: false, error: 'Numero di telefono richiesto' };
    if (cleanPhone.length < 6) return { valid: false, error: 'Numero troppo corto (minimo 6 cifre)' };
    if (cleanPhone.length > 15) return { valid: false, error: 'Numero troppo lungo (massimo 15 cifre)' };
    
    return { valid: true, cleanPhone };
}

// Funzione per sanitizzare l'input
function sanitizePhoneInput(input) {
    if (!input || typeof input !== 'string') return '';
    
    // Rimuovi caratteri pericolosi e mantieni solo numeri, spazi, trattini, parentesi e +
    return input
        .trim()
        .substring(0, 20) // Limita la lunghezza massima
        .replace(/[<>'"&]/g, '') // Rimuovi caratteri HTML pericolosi
        //Rimuove tutti i caratteri che non sono numeri \d, spazi \s, trattini, parentesi tonde e +
        .replace(/[^\d\s\-\(\)+]/g, ''); // Mantieni solo caratteri validi per telefoni
}

function showPhoneError(message) {
    const errorElement = document.getElementById('phoneErrorMessage');
    if (errorElement) {
        // Usa textContent per prevenire XSS, tutto quello che viene inserito viene trasformato in testo
        errorElement.textContent = message;
        errorElement.style.display = 'block';
        errorElement.style.color = '#dc3545';
        errorElement.style.fontSize = '14px';
        errorElement.style.marginTop = '10px';
    }
}

function hidePhoneError() {
    const errorElement = document.getElementById('phoneErrorMessage');
    if (errorElement) {
        errorElement.style.display = 'none';
    }
}

window.confirmPhoneNumber = function() {
    console.log('📞 Avvio conferma numero di telefono sicura');
    
    try {
        // Nascondi eventuali errori precedenti
        hidePhoneError();
        
        // Ottieni il valore dal campo input
        const phoneInput = document.getElementById('phoneVerificationInput');
        if (!phoneInput) {
            console.error('❌ Campo input telefono non trovato');
            return false;
        }
        
        // Sanitizza l'input
        const rawPhoneValue = phoneInput.value || '';
        const sanitizedPhone = sanitizePhoneInput(rawPhoneValue);
        
        // console.log('📝 Numero originale:', rawPhoneValue);
        // console.log('🧹 Numero sanitizzato:', sanitizedPhone);
        
        // Valida il numero
        const validation = validatePhoneNumber(sanitizedPhone);
        if (!validation.valid) {
            console.warn('⚠️ Validazione fallita:', validation.error);
            showPhoneError(validation.error);
            return false;
        }
        
        const validatedPhone = validation.cleanPhone;
        console.log('✅ Numero validato:', validatedPhone);
        
        // Aggiorna il campo originale in modo sicuro
        const originalPhoneInput = document.getElementById('es-phone');
        if (originalPhoneInput) {
            // Usa una whitelist di caratteri per il valore finale
            const safePhoneValue = validatedPhone.replace(/[^\d+\-\s\(\)]/g, '');
            originalPhoneInput.value = safePhoneValue;
            
            // Trigger degli eventi in modo sicuro
            try {
                originalPhoneInput.dispatchEvent(new Event('input', { bubbles: true }));
                originalPhoneInput.dispatchEvent(new Event('change', { bubbles: true }));
                console.log("📲 Campo #es-phone aggiornato con:", safePhoneValue);
            } catch (eventError) {
                console.error('❌ Errore nel dispatch degli eventi:', eventError);
            }
        }
        
        // Aggiorna i dati dell'ordine pending in modo sicuro
        if (window.pendingOrder && typeof window.pendingOrder === 'object') {
            // Usa solo il numero pulito senza caratteri speciali per il confronto
            window.pendingOrder.phone = validatedPhone.replace(/[\s\-\(\)+]/g, '');
            console.log("📞 Telefono aggiornato in pendingOrder:", window.pendingOrder.phone);
        }
        
        // Chiudi il popup
        hidePhoneVerificationPopup();
        
        // Procedi con il controllo duplicati
        if (window.pendingOrder) {
            const duplicate = checkForDuplicate(window.pendingOrder);
            if (duplicate) {
                showDuplicateWarning(duplicate, window.pendingOrder);
            } else {
                saveOrder(window.pendingOrder);
                window.allowSubmit = true;
                
                // Click sicuro sul pulsante
                setTimeout(() => {
                    const submitButton = document.getElementById('es-form-button');
                    if (submitButton && typeof submitButton.click === 'function') {
                        submitButton.click();
                    }
                }, 100);
                
                window.pendingOrder = null;
            }
        }
        
        return true;
        
    } catch (error) {
        console.error('❌ Errore in confirmPhoneNumber:', error);
        showPhoneError('Errore durante la validazione. Riprova.');
        return false;
    }
}

// === FUNZIONI GLOBALI PER I PULSANTI ===
window.cancelNewOrder = function() {
    console.log('❌ Utente ha annullato il nuovo ordine');
    hideDuplicateWarning();
    window.pendingOrder = null;
    window.allowSubmit = false;
}

window.cancelPhoneVerification = function() {
    console.log('❌ Utente ha annullato la verifica telefono');
    hidePhoneVerificationPopup();
    window.pendingOrder = null;
    window.allowSubmit = false;
    window.phoneVerified = false;
}

window.proceedWithOrder = function() {
    console.log('✅ Utente ha scelto di procedere con l\'ordine');
    hideDuplicateWarning();
    
    if (window.pendingOrder) {
        saveOrder(window.pendingOrder);
        window.allowSubmit = true;
        
        // Trova e clicca il pulsante EasyCodSell
        setTimeout(() => {
            const submitButton = document.getElementById('es-form-button');
            if (submitButton) {
                console.log('🔘 Cliccando il pulsante submit...');
                submitButton.click();
            } else {
                console.error('❌ Pulsante submit non trovato!');
            }
        }, 100);
        
        window.pendingOrder = null;
    }
}

// === ESTRAZIONE DATI ORDINE ===
function extractOrderData() {
    // Estrai il nome del prodotto
    const productTitleElement = document.querySelector('.es-product-title');
    const productName = productTitleElement ? productTitleElement.textContent.trim() : 'Prodotto';
    
    // Estrai i dati dai campi del form
    const nameInput = document.getElementById('es-last_name');
    const phoneInput = document.getElementById('es-phone');
    const emailInput = document.getElementById('es-email');
    
    const orderData = {
        productName: productName,
        customerName: nameInput ? nameInput.value.trim() : '',
        phone: phoneInput ? phoneInput.value.replace(/[\s\-\(\)]/g, '') : '',
        email: emailInput ? emailInput.value.trim() : ''
    };
    
    console.log('📊 Dati ordine estratti:', orderData);
    return orderData;
}

function isFormValid() {
    const nameInput = document.getElementById('es-last_name');
    const phoneInput = document.getElementById('es-phone');
    
    const name = nameInput ? nameInput.value.trim() : '';
    const phone = phoneInput ? phoneInput.value.trim() : '';
    
    // Controlla se i campi obbligatori sono compilati
    if (!name || name.length < 2) {
        console.log('❌ Nome mancante o troppo corto');
        return false;
    }
    
    if (!phone || phone.length < 5) {
        console.log('❌ Telefono mancante o troppo corto');
        return false;
    }
    
    console.log('✅ Form valido');
    return true;
}

// === INTERCETTAZIONE PULSANTE ===
function interceptEasyCodSellButton() {
    console.log('🔍 Cercando il pulsante EasyCodSell...');
    
    const submitButton = document.getElementById('es-form-button');
    
    if (!submitButton) {
        console.log('❌ Pulsante es-form-button non trovato');
        return false;
    }
    
    if (submitButton.dataset.duplicateCheckAdded) {
        console.log('✅ Pulsante già intercettato');
        return true;
    }
    
    submitButton.dataset.duplicateCheckAdded = 'true';
    console.log('✅ Pulsante es-form-button trovato e intercettato');
    
    // Intercetta tutti i tipi di eventi sul pulsante
    ['click', 'mousedown', 'touchstart'].forEach(eventType => {
        submitButton.addEventListener(eventType, function(e) {
            console.log(`🔘 ${eventType} intercettato sul pulsante INVIA ORDINE`);
            
            // Se il submit è già autorizzato, lascia passare
            if (window.allowSubmit) {
                console.log('✅ Click autorizzato, procedo con l\'invio');
                window.allowSubmit = false;
                return true;
            }
            
            // Blocca l'evento
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            console.log('🛑 Click bloccato per controllo duplicati');
            
            // Controlla se il form è valido prima di procedere
            if (!isFormValid()) {
                console.log('❌ Form non valido, lascio gestire a EasyCodSell');
                window.allowSubmit = true;
                setTimeout(() => submitButton.click(), 50);
                return false;
            }
            
            // Controlla se il form è valido prima di procedere
            if (!isFormValid()) {
                console.log('❌ Form non valido, lascio gestire a EasyCodSell');
                window.allowSubmit = true;
                setTimeout(() => submitButton.click(), 50);
                return false;
            }
            
            // Estrai i dati del form
            const orderData = extractOrderData();

            // Se il telefono non è ancora stato verificato
            if (!window.phoneVerified) {
                showPhoneVerificationPopup(orderData);
                return false;
            }

  
            // Controlla se è un duplicato
            const duplicate = checkForDuplicate(orderData);
            
            if (duplicate) {
                console.log('⚠️ Duplicato trovato!', duplicate);
                showDuplicateWarning(duplicate, orderData);
            } else {
                console.log('✅ Nessun duplicato trovato, salvo e procedo');
                saveOrder(orderData);
                window.allowSubmit = true;
                
                // Simula il click originale dopo un breve delay
                setTimeout(() => {
                    console.log('🔄 Richiamando il click sul pulsante...');
                    submitButton.click();
                }, 100);
            }
            
            return false;
        }, true); // true = capture phase per intercettare prima
    });
    
    return true;
}

function createPopupHTML() {
  const popupHTML = `
    <div id="duplicateWarningOverlay" style="display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.8); z-index: 2147483647; overflow: hidden;">
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #fff; border-radius: 12px; padding: 30px; max-width: 90%; width: 400px; max-height: 90vh; overflow-y: auto; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3); text-align: center; font-family: Arial, sans-serif;">
        <div style="font-size: 48px; color: #ff9800; margin-bottom: 20px;">⚠️</div>
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 15px;">Attenzione! Ordine già effettuato</div>
        <div style="font-size: 16px; color: #666; margin-bottom: 25px;">Sembra che tu abbia già effettuato un ordine simile di recente.<br>Il tuo precedente ordine è stato ricevuto correttamente e sarà processato.</div>
        <div style="background: #f5f5f5; padding: 15px; border-radius: 8px; margin-bottom: 25px; text-align: left;">
          <h4 style="margin: 0 0 10px 0; font-size: 16px; color: #333; font-weight: bold;">Dettagli ordine precedente:</h4>
          <p id="prevOrderTime" style="margin: 5px 0; font-size: 14px; color: #555;"></p>
          <p id="prevOrderProduct" style="margin: 5px 0; font-size: 14px; color: #555;"></p>
          <p id="prevOrderPhone" style="margin: 5px 0; font-size: 14px; color: #555;"></p>
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 12px; justify-content: center;">
          <button id="cancelOrderBtn" style="padding: 12px 20px; border-radius: 6px; font-size: 16px; border: none; background: #28a745; color: white; cursor: pointer; font-weight: 600; min-width: 140px;">Annulla nuovo ordine</button>
          <button id="proceedOrderBtn" style="padding: 12px 20px; border-radius: 6px; font-size: 16px; border: none; background: #dc3545; color: white; cursor: pointer; font-weight: 600; min-width: 140px;">Procedi comunque</button>
        </div>
      </div>
    </div>

    <div id="phoneVerificationOverlay" style="display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.8); z-index: 2147483647;">
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #fff; border-radius: 12px; padding: 30px; width: 420px; max-width: 90%; text-align: center; font-family: Arial, sans-serif;">
        <div style="font-size: 48px; color: #2196F3; margin-bottom: 20px;">📞</div>
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 15px;">Verifica il tuo numero</div>
        <div style="font-size: 15px; color: gray; margin-bottom: 15px;">Sempre meglio dare un'ultima occhiatina, controlla se il tuo numero è corretto, così possiamo chiamarti</div>
        <div style="background: #f5f5f5; padding: 20px; border-radius: 8px; margin-bottom: 25px;">
          <p style="margin: 0 0 15px 0; font-size: 16px; color: #666;">Numero di telefono:</p>
          <input type="tel" 
                 id="phoneVerificationInput" 
                 placeholder="Inserisci il tuo numero di telefono" 
                 maxlength="20"
                 autocomplete="tel"
                 style="width: 100%; padding: 12px; border: 2px solid #ddd; border-radius: 6px; font-size: 16px;">
          <div id="phoneErrorMessage" style="display: none; margin-top: 10px; color: #dc3545; font-size: 14px;"></div>
        </div>
        <div style="display: flex; gap: 12px; justify-content: center;">
          <button id="cancelPhoneBtn" style="padding: 12px 20px; border: none; background: #6c757d; color: white; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 600;">Annulla</button>
          <button id="confirmPhoneBtn" style="padding: 12px 24px; border: none; background: #28a745; color: white; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 600;">Conferma Numero</button>
        </div>
      </div>
    </div>
  `;

    return popupHTML;
}


// === INIZIALIZZAZIONE ===
function initializeDuplicateChecker() {
    console.log('🚀 Inizializzazione controllo duplicati EasyCodSell...');
    
        // Crea il popup se non esiste
        if (!document.getElementById('duplicateWarningOverlay')) {
            document.body.insertAdjacentHTML('beforeend', createPopupHTML());
            //console.log('✅ Popup HTML creato');
        }

        // Aggiungi event listeners ai pulsanti del popup duplicati
        const cancelBtn = document.getElementById('cancelOrderBtn');
        const proceedBtn = document.getElementById('proceedOrderBtn');
        
        if (cancelBtn) {
            cancelBtn.addEventListener('click', window.cancelNewOrder);
            cancelBtn.addEventListener('mouseenter', function() {
                this.style.background = '#218838';
            });
            cancelBtn.addEventListener('mouseleave', function() {
                this.style.background = '#28a745';
            });
        }
        
        if (proceedBtn) {
            proceedBtn.addEventListener('click', window.proceedWithOrder);
            proceedBtn.addEventListener('mouseenter', function() {
                this.style.background = '#c82333';
            });
            proceedBtn.addEventListener('mouseleave', function() {
                this.style.background = '#dc3545';
            });
        }
        
        // Aggiungi event listeners ai pulsanti del popup verifica telefono
        const confirmPhoneBtn = document.getElementById('confirmPhoneBtn');
        const cancelPhoneBtn = document.getElementById('cancelPhoneBtn');
        
        if (confirmPhoneBtn) {
            confirmPhoneBtn.addEventListener('click', window.confirmPhoneNumber);
            confirmPhoneBtn.addEventListener('mouseenter', function() {
                this.style.background = '#218838';
            });
            confirmPhoneBtn.addEventListener('mouseleave', function() {
                this.style.background = '#28a745';
            });
        }
        
        if (cancelPhoneBtn) {
            cancelPhoneBtn.addEventListener('click', window.cancelPhoneVerification);
            cancelPhoneBtn.addEventListener('mouseenter', function() {
                this.style.background = '#5a6268';
            });
            cancelPhoneBtn.addEventListener('mouseleave', function() {
                this.style.background = '#6c757d';
            });
        }
        
        console.log('✅ Event listeners aggiunti a tutti i pulsanti');
    
    // Intercetta il pulsante EasyCodSell
    interceptEasyCodSellButton();
}

// === AVVIO AUTOMATICO ===
document.addEventListener('DOMContentLoaded', function() {
    initializeDuplicateChecker();
    
    // Riprova dopo 1 secondo (per contenuti dinamici)
    setTimeout(() => {
        console.log('🔄 Secondo tentativo di inizializzazione...');
        initializeDuplicateChecker();
    }, 1000);
    
    // Riprova dopo 3 secondi
    setTimeout(() => {
        console.log('🔄 Terzo tentativo di inizializzazione...');
        initializeDuplicateChecker();
    }, 3000);
});

// === OBSERVER PER CONTENUTI DINAMICI ===
const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
            for (let node of mutation.addedNodes) {
                if (node.nodeType === 1 && (
                    node.id === 'es-form-button' || 
                    node.querySelector('#es-form-button') ||
                    node.id === 'easysell-modal' ||
                    node.querySelector('#easysell-modal')
                )) {
                    shouldCheck = true;
                    break;
                }
            }
        }
    });
    
    if (shouldCheck) {
        console.log('🔄 Nuovo contenuto rilevato, reinizializzo...');
        setTimeout(initializeDuplicateChecker, 100);
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

// === FUNZIONE DI DEBUG ===
window.debugDuplicateCheck = function() {
    console.log('🔧 DEBUG: Test manuale controllo duplicati');
    const orderData = extractOrderData();
    console.log('Dati estratti:', orderData);
    
    const duplicate = checkForDuplicate(orderData);
    if (duplicate) {
        console.log('Duplicato trovato:', duplicate);
        showDuplicateWarning(duplicate, orderData);
    } else {
        console.log('Nessun duplicato trovato');
        // Aggiungi un ordine di test
        saveOrder(orderData);
        console.log('Ordine di test salvato');
    }
};

console.log('🎯 Script controllo duplicati EasyCodSell caricato completamente');